import { CellType } from '../../cell/cell-type-service';
import cssVars from '../../scss-to-js-vars.module.scss';
import { SortableHeaderCell } from '../header-cell/sortable-header-cell';
import { HeaderCheckboxCell } from '../header-checkbox-cell/header-checkbox-cell';
export const DEFAULT_COL_DEF = {
    sortable: true,
    headerComponent: SortableHeaderCell,
    resizable: false,
};
const createCell = ({ cellType, headerComponent, flex, width, suppressSizeToFit, resizable, suppressMovable, headerCheckboxSelection, headerClass = '', headerCheckboxSelectionFilteredOnly, }) => {
    const cell = {
        headerName: '',
        cellRenderer: CellType[cellType],
        field: CellType[cellType],
        sortable: false,
        colId: CellType[cellType],
        headerClass,
    };
    if (headerComponent) {
        cell.headerComponent = headerComponent;
    }
    if (width) {
        cell.width = width;
    }
    else {
        cell.flex = 1;
    }
    if (suppressSizeToFit !== undefined) {
        cell.suppressSizeToFit = suppressSizeToFit;
    }
    if (resizable !== undefined) {
        cell.resizable = resizable;
    }
    if (flex) {
        cell.flex = flex;
    }
    if (suppressMovable) {
        cell.suppressMovable = true;
    }
    if (headerCheckboxSelection) {
        cell.headerCheckboxSelection = true;
    }
    if (headerCheckboxSelectionFilteredOnly) {
        cell.headerCheckboxSelectionFilteredOnly = true;
    }
    return cell;
};
export const addCommonCells = (props) => {
    const { columns, hasCheckboxes, rowMenu, rowActionItems, hideSelectAllCheckbox, suppressMovable, headerClass, customWidth = Number(cssVars.metadatalistcheckboxcellwidth), } = props;
    let tableColumns = columns;
    if (hasCheckboxes) {
        const checkColumDef = createCell({
            cellType: CellType.checkbox,
            headerComponent: !hideSelectAllCheckbox && HeaderCheckboxCell,
            width: customWidth,
            suppressSizeToFit: true,
            resizable: false,
            suppressMovable,
            headerCheckboxSelection: true,
            headerClass,
            headerCheckboxSelectionFilteredOnly: true,
        });
        tableColumns = [checkColumDef, ...columns];
    }
    if (rowActionItems) {
        const actionColumDef = createCell({
            cellType: CellType.hoverAction,
            flex: 2,
        });
        tableColumns = [...tableColumns, actionColumDef];
    }
    if (rowMenu) {
        const menuColumDef = createCell({
            cellType: CellType.menu,
            flex: 1,
            headerComponent: () => null,
        });
        tableColumns = [...tableColumns, menuColumDef];
    }
    return tableColumns;
};
//# sourceMappingURL=header-definition-service.js.map